import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { GwcApiConnService } from './gwc-api-conn.service';
import { Institution } from './types/institution.types'
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class GwcApiInstitutionService {

    private _institutions: Institution[] = [];

	/**
     * Constructor
     */
    constructor(
		private _gwcApiConn: GwcApiConnService
	) {

	}


    //--------------------------------------------------------------------------------
    // @Public Methods
    //--------------------------------------------------------------------------------

    /**
     * Get casual hire institutions
     */
    public getTertiaryInstitutions() {
        return this._gwcApiConn.request('GET', ['Institution'], {type: 'UNIVERSITY,POLYTECH,OTHER_TERTIARY'}) as Observable<Institution[]>
    }


    public getCasualHireInstitutions(): Observable<Institution[]> {
        return this._gwcApiConn.request('GET', ['Institution'], { casual_hire: '1' }) as Observable<Institution[]>
    }


    public details(institution_id: string) {
        if(this._institutions.find(inst => inst.institution_id == institution_id)) {
            return of(this._institutions.find(inst => inst.institution_id == institution_id))
        }

        return this._gwcApiConn.request('GET', ['Institution', institution_id]).pipe(
            map((institution: any) => {
                this._institutions.push(institution as Institution);
                return institution;
            })
        )
    }






}